import React, { useState, useCallback } from "react";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import KeyForm from "./KeyForm";

function KeyName({ params }) {
  const [openRenameBoardKey, setOpenRenameBoardKey] = useState(false);

  const handleClose = useCallback(() => {
    setOpenRenameBoardKey(false);
  }, []);

  const handleClick = useCallback((event) => {
    setOpenRenameBoardKey(true);
  }, []);

  
  return (
    <>
      {openRenameBoardKey && (
        <FormDialog
          open={openRenameBoardKey}
          handleClose={handleClose}
          title={"Rename Board Key"}
          btnTitle={"Update"}
          fullWidth={true}
        >
          <KeyForm params={params} onClose={handleClose} />
        </FormDialog>
      )}
      <div onClick={handleClick} className="cursor-pointer">
        <p className="underline uppercase">{params.value}</p>
      </div>
    </>
  );
}

const isChangeKeyName = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.board_id === nextProps?.params?.row?.board_id
    && prevProps?.params?.row?.key === nextProps?.params?.row?.key
    && prevProps?.params?.value === nextProps?.params?.value
    && prevProps?.params?.row?.board_name === nextProps?.params?.row?.board_name
  );
};

export default React.memo(KeyName,isChangeKeyName);
